import { Component } from '@angular/core';

@Component({
    selector: 'app-login-failed',
    template: '<p>Login failed. Please try again.</p>',
    standalone: false
})
export class LoginFailedComponent {}
